// extracted by mini-css-extract-plugin
export var box = "_2x-0";
export var check = "_2x-1";
export var checkboxButton = "_2x-6";
export var checkboxGroup = "_2x-5";
export var disabled = "_2x-7";
export var ghost = "_2x-9";
export var input = "_2x-2";
export var label = "_2x-4";
export var normal = "_2x-8";
export var uncheck = "_2x-3";